module.exports = __webpack_public_path__ + "static/media/indexSection5Image.8298f508.svg";